import SignalContent from "../signal_content";
import { RequestSignallampParamsMaker } from "./make_signallamp_request_params";
import axios from "axios";
import CognitoController from "../../../common/scripts/cognito_controller";
import { makeSensorData } from "./make_signallamp_sensor_data";
import { i18n } from "@/main";

export async function getSignallampSensorData(
  self: SignalContent,
  authStore: any,
) {
  try {
    await CognitoController.refreshToken();
    const userId = self.user_id;
    const requestParams = RequestSignallampParamsMaker.makeGetSignallampSensorDataParams(
      self,
      userId,
      authStore,
      self.selectDeviceId,
      self.mstSignallampSetting,
    );
    const apiResponse = await axios(requestParams);
    let newSignallampSensorData = null;
    if (apiResponse.data.res.signallamp_sensor_data) {
      newSignallampSensorData = apiResponse.data.res.signallamp_sensor_data[0];
    }
    self.latestDataDate = newSignallampSensorData !== [] ? makeSensorData(self, newSignallampSensorData) : self.$t("message.notAcquired") as string;
    if (newSignallampSensorData && newSignallampSensorData.sensor_data_transmission_check_flag) {
      if (newSignallampSensorData.sensor_data_transmission_check_flag === "true" && !self.errorMassageFlag) {
        self.errorMassageFlag = true;
        // 変数入りのメッセージが文法上おかしくないようif分岐
        if (i18n.locale === "ja") {
          self.errorMassage = self.$t("message.exclamationMark") + self.selectDeviceId + self.$t("message.dataHasNotBeenSentForMoreThan1MinutesFrom");
        } else {
          self.errorMassage = self.$t("message.dataHasNotBeenSentForMoreThan1MinutesFrom") + self.selectDeviceId;
        }
      }
    } else {
      self.errorMassageFlag = false;
      self.errorMassage = "";
    }
    return newSignallampSensorData;
  } catch (err) {
    console.log(err);
    self.errorCheck = true;
  }
}
